module.exports = __webpack_public_path__ + "static/img/ceallach.95fc836.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/ceallach.png
// module id = LQ7E
// module chunks = 0